import { Label } from "reactstrap";
import { H4, Image, LI, P } from "../../../../AbstractElements";
import { Meetup, USMeeting } from "../../../../Constant";
import { MEETUP_HOVERING } from "../../../../Data/Bonus Ui/Timeline";

export const MeetupHoveringTimeline = () => {
  return (
    <LI className="timeline-event">
      <Label className="timeline-event-icon"></Label>
      <div className="timeline-event-wrapper">
        <P className="timeline-thumbnail">{Meetup}</P>
        <H4>{USMeeting}</H4>
        <span className="text-muted">2209 Leverton Cove RoadSpringfield, MA 01109</span>
        <div className="pt-3 mb-0">
          <div className="designer-details">
          {MEETUP_HOVERING.map(({image,name,number},index) => (
               <div className='designer-profile' key={index}>
                 <div className='designer-wrap'>
                   <Image className='designer-img' src={image} alt='profile' />
                   <div className='designer-content'>
                     <H4 className="f-w-700">{name}</H4>
                     <P>{number}</P>
                   </div>
                 </div>
               </div>
             ))}
          </div>
        </div>
      </div>
    </LI>
  );
};
